import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { ILov } from '../../../../../type_definitions/datatypes';

@Component({
  selector: 'ranking-label',
  template: `
    <div class="value-label-ranking-acsl badge" [id]="identifier" [ngClass]="classNames" [innerHTML]="formattedValue"></div>
  `
})
export class RankingLabelComponent implements OnChanges {
  @Input() public ranking:ILov;
  @Input() public identifier:string;
  public classNames:string;

  constructor(
    private formattingService:FormattingService
  ) {
    /**/
  }

  public get formattedValue():string {
    return this.formattingService.formatLov(this.ranking);
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.ranking) {
      this.ranking = changes.ranking.currentValue;
      this.classNames = this.formattingService.getRankingLabelClass(this.ranking);
    }
  }
}